import {
    IContentBoxResponse,
    LocalizedServiceFeeConfig,
    ProductConfiguration,
    ProductDto,
    ProductLineImage,
} from '@modeso/types__dgoods-products';
import { MerchantType } from '../enums/merchantType.enum';
import { ProductType } from '../enums/productType.enum';

export interface ShopProductLine {
    productLineId: string;
    productLineName: string;
    productLineCaption: string;
    locale: string;
    productLineImages: ProductLineImage[];
    availableProducts: ProductDto[];
    blocked?: boolean;
    whiteListed?: boolean;
    merchantDetails: any;
    merchantId: string;
    termsAndConditions: string;
    productLineDescription: string;
    productConfiguration?: ProductConfiguration;
    redeemText: string;
    displayOnIOS?: boolean;
    displayOnAndroid?: boolean;
    couponsEnabled?: boolean;
    isGreyedOut?: boolean;
    serviceFee?: boolean;
    serviceFeeConfig?: LocalizedServiceFeeConfig;
    merchantType?: MerchantType;
    hasDigitalVocherConfig?: boolean;
    needsKYC?: boolean;
    contentBox?: IContentBoxResponse;
    type: ProductType;
}
